import { IContact, ILogisticsOption, ILogisticsOptionNote } from ".";

export interface ILogisticsWithOption {
    chainId: number,
    clusterNumber: number,
    position: number,
    earliestPickupTime: string,
    latestDropoffTime: string,
    opo: string,
    recipientId: number,
    recipientAlias: string,
    recipientCenter: string,
    recipientCenterId: number,
    recipientCenterTimezone: string,
    donorId: number,
    donorAlias: string,
    donorCenter: string,
    donorCenterId: number,
    donorCenterTimezone: string,
    rdnCenterId: number,
    rdnCenterAlias: string,
    logisticsProvider: string,
    logisticsProviderName: string,
    kidneyPickupDateTime: string,
    kidneyArrivalDateTime: string,
    deadline: string,
    notes: ILogisticsOptionNote[],
    list: ILogisticsOption[]
}